export default __webpack_public_path__ + "fb4a875965fd9d26b539ae19e2435dd4.png";